/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _objectDestructuringEmpty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectDestructuringEmpty");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.name = exports.ScrollListener = void 0;

var react_1 = __importDefault(require("react"));

var brightsmith_core_1 = require("brightsmith-core");

var name = 'ScrollListener';
exports.name = name;

var ScrollListener = function ScrollListener(_ref) {
  _objectDestructuringEmpty(_ref);

  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.clear = _this.clear.bind(_assertThisInitialized(_this));
      _this.handleScroll = _this.handleScroll.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "clear",
      value: function clear() {
        if (!brightsmith_core_1.Util.isReactNative()) {
          var classList = document.body.classList;
          var bodyClasses = this.props.bodyClasses;
          Object.keys(bodyClasses).forEach(function (bodyClass) {
            return classList.remove(bodyClass);
          });
        }
      }
    }, {
      key: "evaluate",
      value: function evaluate(condition, event) {
        var _a;

        var scrollTop = (_a = event.srcElement.scrollingElement.scrollTop) !== null && _a !== void 0 ? _a : 0;
        var _condition$comparator = condition.comparator,
            comparator = _condition$comparator === void 0 ? '=' : _condition$comparator;
        var value = this.getValue(condition);

        try {
          return eval("".concat(scrollTop, " ").concat(comparator, " ").concat(value));
        } catch (e) {
          console.error("Error evaluating comparator '".concat(comparator, "' in ScrollListener"), e);
        }

        return false;
      }
    }, {
      key: "getValue",
      value: function getValue(condition) {
        var field = condition.field,
            ref = condition.ref,
            _condition$value = condition.value,
            value = _condition$value === void 0 ? 0 : _condition$value;

        try {
          if (field && ref) {
            return ref.current[field] || value;
          }
        } catch (e) {
          console.error("Error getting value from ref field '".concat(field, " in ScrollListener"), e);
        }

        return value;
      }
    }, {
      key: "handleScroll",
      value: function handleScroll(event) {
        var _this2 = this;

        if (!brightsmith_core_1.Util.isReactNative()) {
          var classList = document.body.classList;
          var bodyClasses = this.props.bodyClasses;
          Object.keys(bodyClasses).forEach(function (bodyClass) {
            var condition = bodyClasses[bodyClass];

            if (_this2.evaluate(condition, event)) {
              classList.add(bodyClass);
              return;
            }

            classList.remove(bodyClass);
          });
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (window.addEventListener) {
          window.addEventListener('scroll', this.handleScroll);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (window.removeEventListener) {
          window.removeEventListener('scroll', this.handleScroll);
        }

        this.clear();
      }
    }, {
      key: "render",
      value: function render() {
        return null;
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.ScrollListener = ScrollListener;